import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";

export default function ActivityPage() {
  const [acts, setActs] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/activity/feed").then((r) => setActs(r.data)).catch(() => setActs([]));
  }, []);

  if (!acts) return <div className="p-8 text-zinc-500">Cargando actividad…</div>;

  return (
    <div className="h-screen overflow-y-auto">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="font-display text-3xl font-extrabold mb-1" data-testid="activity-title">Actividad</h1>
        <p className="text-sm text-zinc-500 mb-8">Todo lo que pasa en tus tableros.</p>
        <div className="space-y-1">
          {acts.map((a, i) => (
            <button key={a.id} onClick={() => navigate(`/boards/${a.board_id}`)} data-testid={`feed-item-${a.id}`}
              style={{ animationDelay: `${Math.min(i * 40, 500)}ms` }}
              className="w-full text-left flex items-start gap-3 px-4 py-3 rounded-xl hover:bg-white/5 transition-colors animate-fade-up">
              <span className="h-2.5 w-2.5 rounded-full mt-1.5 shrink-0" style={{ background: a.user_color || "#FF3B30" }} />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-zinc-300"><span className="font-semibold text-white">{a.user_name}</span> {a.action} · <span className="text-white">{a.task_title}</span></p>
                <p className="text-xs text-zinc-600 mt-0.5">{a.board_name} · {new Date(a.created_at).toLocaleString("es", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</p>
              </div>
            </button>
          ))}
          {acts.length === 0 && <p className="text-sm text-zinc-600">Sin actividad todavía.</p>}
        </div>
      </div>
    </div>
  );
}
